export enum DispatchTimeWindowMethodType {
  perService = "perService",
  perTask = "perTask"
}
